
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarVariableRangeMarkerProposal as ObiRadarVariableRangeMarkerProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-variable-range-marker-proposal.js';
 
 
 

 
 export const ObiRadarVariableRangeMarkerProposal = createComponent({
   react: React,
   tagName: 'obi-radar-variable-range-marker-proposal',
   elementClass: ObiRadarVariableRangeMarkerProposalElement,
   events: {
     
   }
  });
 
 